<template>
    <div class="container-fluid__with-padding-x">
        <div
            class="separator"
        >
            {{ label }}
            <router-link v-if="link" :to="link">{{ labelLink }}</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "Separator",
    props: {
        label: '',
        link: null,
        labelLink: ''
    },
}
</script>

